import {postGeneratorSteps} from '../../typescript';

export function getNextStep(currentStep: postGeneratorSteps): postGeneratorSteps {
  if (currentStep === postGeneratorSteps.manageBeers) return postGeneratorSteps.postType;
  return postGeneratorSteps.postTemplate;
}

export function getPrevStep(currentStep: postGeneratorSteps): postGeneratorSteps {
  if (currentStep === postGeneratorSteps.postTemplate) return postGeneratorSteps.postType;

  return postGeneratorSteps.manageBeers;
}
